import { render, staticRenderFns } from "./regionalStores.vue?vue&type=template&id=10f71cd4&scoped=true"
import script from "./regionalStores.vue?vue&type=script&lang=js"
export * from "./regionalStores.vue?vue&type=script&lang=js"
import style0 from "./regionalStores.vue?vue&type=style&index=0&id=10f71cd4&prod&lang=scss&scoped=true"
import style1 from "./regionalStores.vue?vue&type=style&index=1&id=10f71cd4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f71cd4",
  null
  
)

export default component.exports